import AirDatepicker from 'air-datepicker';
import localeNl from 'air-datepicker/locale/nl';

const wizardBlocks = document.querySelectorAll('.travelbase-wizard');

function toNumber(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
}

function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

function getTodayStart() {
    const today = new Date();

    today.setHours(0, 0, 0, 0);

    return today;
}

function closeDropdown(dropdown) {
    const toggle = dropdown.querySelector('.wizard-dropdown-toggle');
    const panel = dropdown.querySelector('.wizard-dropdown-panel');

    dropdown.classList.remove('open');
    toggle?.setAttribute('aria-expanded', 'false');

    if (panel) {
        panel.hidden = true;
    }
}

function openDropdown(dropdown) {
    const toggle = dropdown.querySelector('.wizard-dropdown-toggle');
    const panel = dropdown.querySelector('.wizard-dropdown-panel');

    dropdown.classList.add('open');
    toggle?.setAttribute('aria-expanded', 'true');

    if (panel) {
        panel.hidden = false;
    }
}

function initDropdownToggles(wizard) {
    const dropdowns = wizard.querySelectorAll('[data-wizard-dropdown]');

    dropdowns.forEach(dropdown => {
        const toggle = dropdown.querySelector('.wizard-dropdown-toggle');

        toggle?.addEventListener('click', () => {
            const isOpen = dropdown.classList.contains('open');

            dropdowns.forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    closeDropdown(otherDropdown);
                }
            });

            if (isOpen) {
                closeDropdown(dropdown);
            } else {
                openDropdown(dropdown);
            }
        });
    });

    document.addEventListener('click', event => {
        if (!wizard.contains(event.target)) {
            dropdowns.forEach(closeDropdown);
        }
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            dropdowns.forEach(closeDropdown);
        }
    });
}

function initTripGroup(wizard) {
    const summary = wizard.querySelector('[data-tripgroup-summary]');
    const rows = wizard.querySelectorAll('[data-tripgroup]');
    const tripGroup = wizard.querySelector('.wizard-tripgroup');
    const guestsLabel = tripGroup?.dataset.tripgroupGuestsLabel || 'gasten';
    const petsLabel = tripGroup?.dataset.tripgroupPetsLabel || 'huisdieren';

    function updateSummary() {
        const adults = toNumber(wizard.querySelector('[data-tripgroup-input="adults"]')?.value);
        const youth = toNumber(wizard.querySelector('[data-tripgroup-input="youth"]')?.value);
        const children = toNumber(wizard.querySelector('[data-tripgroup-input="children"]')?.value);
        const babies = toNumber(wizard.querySelector('[data-tripgroup-input="babies"]')?.value);
        const pets = toNumber(wizard.querySelector('[data-tripgroup-input="pets"]')?.value);

        const guests = adults + youth + children + babies;

        if (summary) {
            summary.textContent = `${guests} ${guestsLabel}, ${pets} ${petsLabel}`;
        }
    }

    rows.forEach(row => {
        const key = row.dataset.tripgroup;
        const min = toNumber(row.dataset.min);
        const valueElement = row.querySelector('[data-tripgroup-value]');
        const hiddenInput = wizard.querySelector(`[data-tripgroup-input="${key}"]`);
        const decrement = row.querySelector('[data-step="down"]');
        const increment = row.querySelector('[data-step="up"]');

        if (!hiddenInput || !valueElement) {
            return;
        }

        function setValue(nextValue) {
            const value = Math.max(min, nextValue);

            hiddenInput.value = String(value);
            valueElement.textContent = String(value);

            if (decrement) {
                decrement.disabled = value <= min;
            }

            updateSummary();
        }

        decrement?.addEventListener('click', () => {
            setValue(toNumber(hiddenInput.value) - 1);
        });

        increment?.addEventListener('click', () => {
            setValue(toNumber(hiddenInput.value) + 1);
        });

        setValue(toNumber(hiddenInput.value));
    });
}

function initDateRange(wizard) {
    const datePickerContainer = wizard.querySelector('[data-wizard-datepicker]');
    const summary = wizard.querySelector('[data-daterange-summary]');
    const arrivalInput = wizard.querySelector('[data-daterange-arrival]');
    const departureInput = wizard.querySelector('[data-daterange-departure]');

    if (!datePickerContainer || !arrivalInput || !departureInput) {
        return;
    }

    const defaultSummary = summary?.textContent || '';

    new AirDatepicker(datePickerContainer, {
        locale: localeNl,
        inline: true,
        range: true,
        multipleDatesSeparator: ' - ',
        dateFormat: 'dd-MM-yyyy',
        minDate: getTodayStart(),
        onSelect({ date, formattedDate }) {
            const dates = Array.isArray(date) ? date : [];
            const formattedDates = Array.isArray(formattedDate) ? formattedDate : [formattedDate];

            if (dates.length > 0) {
                arrivalInput.value = formatDate(dates[0]);
                departureInput.value = formatDate(dates[1] ?? dates[0]);
            } else {
                arrivalInput.value = '';
                departureInput.value = '';
            }

            if (summary) {
                summary.textContent = formattedDates.filter(Boolean).join(' - ') || defaultSummary;
            }
        },
    });
}

wizardBlocks.forEach(wizard => {
    initDropdownToggles(wizard);
    initTripGroup(wizard);
    initDateRange(wizard);
});
